import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ReportsCommonService } from 'src/app/services/reports-common.service';
import * as FileSaver from 'file-saver-es';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { Constants } from 'src/app/constants';
import { AetStateService } from 'src/app/services/aet-state.service';
import { Router } from '@angular/router';
import moment from 'moment';
import { DateTime } from 'luxon';
import { ExcelService } from 'src/app/services/excel.service';
import { MasterSettingsService } from 'src/app/services/master-settings.service';
import { ReplaySubject, startWith, map } from 'rxjs';

@Component({
  selector: 'app-reports-order-info',
  templateUrl: './reports-border-crossing.component.html',
  styleUrls: ['./reports-border-crossing.component.scss'],
  standalone: false // NOSONAR
})
export class ReportsBorderCrossing implements OnInit {
  dropdownOptionOrderSupp: any;
  dropdownOptionOrderPlant: any;
  dropdownOptionOredrRegion: any;
  dropdownOptionOredrTP: any;
  dropdownOptionOrderSts: any;
  selectedOrderRegion: any[] = [];
  selectedOrderPlant: any[] = [];
  selectedOrderTP: any[] = [];
  selectedOrderSts: any[] = [];
  selectedOrderSupp: any[] = [];
  event: any;
  errorMessage: any;
  successMessage: any;
  isAccessible = true;
  nextDate: any;
  newDate: any;
  now = new Date();
  maxDate = moment(new Date()).format('YYYY-MM-DD');
  pastDate = new Date(this.now.getTime() - 86400000);
  test = new Date(
    this.pastDate.getFullYear() - 5,
    this.pastDate.getMonth(),
    this.pastDate.getDate()
  );
  minDate = this.test.toISOString().split('T')[0];
  yesterday = this.pastDate.toISOString().split('T')[0];
  selectedLogisticsPoint: any[] = [];
  dropdownOptionLogisticsPoint: any[];
  masterSettingResponse: any;
  orderFilterCtrl: FormControl = new FormControl();
  filteredOrder: ReplaySubject<any[]> = new ReplaySubject(1);
  logFilterCtrl: FormControl = new FormControl();
  filteredLog: ReplaySubject<any[]> = new ReplaySubject(1);
  orderRegFilterCtrl: FormControl = new FormControl();
  filteredOrderReg: ReplaySubject<any[]> = new ReplaySubject(1);

  orderTpFilterCtrl: FormControl = new FormControl();
  filteredOrderTp: ReplaySubject<any[]> = new ReplaySubject(1);
  oderStsFilterCtrl: FormControl = new FormControl();
  filteredOrderSts: ReplaySubject<any[]> = new ReplaySubject(1);
  plantFilterCtrl: FormControl = new FormControl(); const_prgrs = 'In Progress'
  filteredPlant: ReplaySubject<any[]> = new ReplaySubject(1); const_started = 'Not Started'
  constructor(
    public formBuilder: FormBuilder,
    private readonly commonService: ReportsCommonService,
    private readonly ngxUiLoaderService: NgxUiLoaderService,
    public constants: Constants,
    private readonly aetStateService: AetStateService,
    private readonly router: Router,
    private readonly excelService: ExcelService,
    private readonly service: MasterSettingsService
  ) {
const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    const userAttributes = fgaDetails?.user?.applicationUserAttribute?.[0]?.userAttributes ?? [];
    const getAttr = (key: string) => userAttributes.find((a: any) => a.key === key)?.value ?? null;
    const userInfo = {
      userPrincipalName: fgaDetails?.user?.userPrincipalName,
      externalUserId: fgaDetails?.user?.externalUserId,
      additionalSupplierCodes: getAttr('additionalSupplierCodes'),
      additionalLpCode: getAttr('additionalLpCode'),
      additionalNAMC: getAttr('additionalNAMC'),
      additionalDomicile: getAttr('additionalDomicile'),
      firstName: fgaDetails?.user?.firstName,
      lastName: fgaDetails?.user?.lastName,
      email: fgaDetails?.user?.email,
      roles: (fgaDetails?.roles ?? []).map((r: any) => r.displayName),
    };
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.commonService.getCommonReportByUser(userInfo).subscribe(
      (data) => { // NOSONAR
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        if (data) {
          this.event = data;

          if (
            this.event.body.oreportSuppliers &&
            this.event.body.oreportSuppliers.length > 0
          ) {
            this.event.body.oreportSuppliers.sort((a, b) => {
              const valueA = a.supplierName?.toLowerCase() ?? '';
              const valueB = b.supplierName?.toLowerCase() ?? '';

              if (valueA < valueB) {
                return -1;
              }

              if (valueA > valueB) {
                return 1;
              }

              return 0;
            });
            this.dropdownOptionOrderSupp = [];
            //this.dropdownOptionOrderSupp.push({ label: 0, value: 'ALL' })
            this.event.body.oreportSuppliers.forEach((obj, _index) => {
              const supplierCode = this.asNonEmptyString(obj?.supplierCode);
              const supplierName = this.asNonEmptyString(obj?.supplierName);
              const option = this.createOption(
                supplierCode,
                supplierCode && supplierName ? `${supplierCode} - ${supplierName}` : null
              );
              if (option) {
                this.dropdownOptionOrderSupp.push(option);
              }
              this.filteredOrder.next(this.dropdownOptionOrderSupp?.slice());

            });
            this.selectedOrderSupp = this.dropdownOptionOrderSupp;
            this.form?.get('supplier')?.setValue([...this.dropdownOptionOrderSupp]);
          }
          if (
            this.event.body.reportPlants &&
            this.event.body.reportPlants.length > 0
          ) {
            this.event.body.reportPlants.sort((a, b) => {
              const valueA = a.itemCode?.toLowerCase() ?? '';
              const valueB = b.itemCode?.toLowerCase() ?? '';

              if (valueA < valueB) {
                return -1;
              }

              if (valueA > valueB) {
                return 1;
              }

              return 0;
            });
            this.dropdownOptionOrderPlant = [];
            //this.dropdownOptionOrderPlant.push({ label: 0, value: 'ALL' })
            this.event.body.reportPlants.forEach((obj, _index) => {
              const option = this.createOption(obj?.itemCode, obj?.itemCode);
              if (option) {
                this.dropdownOptionOrderPlant.push(option);
              }
              this.filteredPlant.next(this.dropdownOptionOrderPlant?.slice());

            });
            this.selectedOrderPlant = this.dropdownOptionOrderPlant;
            this.form?.get('plant')?.setValue([...this.dropdownOptionOrderPlant]);
          }
          if (
            this.event.body.cbLogisticsPoint &&
            this.event.body.cbLogisticsPoint.length > 0
          ) {

            this.event.body.cbLogisticsPoint.sort((a, b) => {
              const valueA = a?.toLowerCase() ?? '';
              const valueB = b?.toLowerCase() ?? '';

              if (valueA < valueB) {
                return -1;
              }

              if (valueA > valueB) {
                return 1;
              }

              return 0;
            });
            this.dropdownOptionLogisticsPoint = [];
            this.event.body.cbLogisticsPoint.forEach((obj, _index) => {
              const option = this.createOption(obj, obj);
              if (option) {
                this.dropdownOptionLogisticsPoint.push(option);
              }
              this.filteredLog.next(this.dropdownOptionLogisticsPoint?.slice());

            });
            this.selectedLogisticsPoint = this.dropdownOptionLogisticsPoint;
            this.form?.get('logisticsPoint')?.setValue([...this.dropdownOptionLogisticsPoint]);
          }
          if (
            this.event.body.oreportRegions &&
            this.event.body.oreportRegions.length > 0
          ) {
            this.dropdownOptionOredrRegion = [];
            //this.dropdownOptionOredrRegion.push({ label: 0, value: 'ALL' })
            this.event.body.oreportRegions.forEach((obj, _index) => {
              const option = this.createOption(obj?.regionDesc, obj?.regionCode);
              if (option) {
                this.dropdownOptionOredrRegion.push(option);
              }
              this.filteredOrderReg.next(this.dropdownOptionOredrRegion?.slice());

            });
            this.selectedOrderRegion = this.dropdownOptionOredrRegion;
            this.form?.get('region')?.setValue([...this.dropdownOptionOredrRegion]);
          }
          if (
            this.event.body.oreportVendors &&
            this.event.body.oreportVendors.length > 0
          ) {

            this.event.body.oreportVendors.sort((a, b) => {
              const valueA = a.shortName?.toLowerCase() ?? '';
              const valueB = b.shortName?.toLowerCase() ?? '';

              if (valueA < valueB) {
                return -1;
              }

              if (valueA > valueB) {
                return 1;
              }

              return 0;
            });
            this.dropdownOptionOredrTP = [];
            // this.dropdownOptionOredrTP.push({ label: 0, value: 'ALL' })
            this.event.body.oreportVendors.forEach((obj, _index) => {
              const option = this.createOption(obj?.vendorId, obj?.shortName);
              if (option) {
                this.dropdownOptionOredrTP.push(option);
              }
              this.filteredOrderTp.next(this.dropdownOptionOredrTP?.slice());

            });
            this.selectedOrderTP = this.dropdownOptionOredrTP;
            this.form?.get('transport_Provider')?.setValue([...this.dropdownOptionOredrTP]);
          }
          this.dropdownOptionOrderSts = [
            { label: 'Arrived', value: 'Arrived' },
            { label: this.const_prgrs, value: this.const_prgrs },
            { label: 'Late', value: 'Late' },
            { label: this.const_started, value: this.const_started },
          ];
          this.filteredOrderSts.next(this.dropdownOptionOrderSts?.slice());

          this.selectedOrderSts = this.dropdownOptionOrderSts;
          this.form?.get('status')?.setValue([...this.dropdownOptionOrderSts]);
        }
      },
      (_err) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.downloadError;
      }
    );
  }

  settingsDataMap() {
    this.service.loadMasterSettingsOfDomicile().subscribe((response: any) => {
      console.info('Response', response);
      this.masterSettingResponse = response;
    });
  }

  form!: FormGroup;
  submitted: boolean = false;
  curDate = formatDate(new Date(), 'yyyy/MM/dd', 'en');

  ngOnInit() {
    // this.checkRoles();
    this.form = this.formBuilder.group({
      supplier: [''],
      plant: [''],
      logisticsPoint: [''],
      region: [''],
      transport_Provider: [''],
      status: [''],
      start_Date: ['', [Validators.required]],
      end_Date: ['', [Validators.required]],
    });
    this.settingsDataMap();
    this.orderTpFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionOrderSupp) : this.dropdownOptionOrderSupp?.slice())
      )
      .subscribe(filtered => {
        this.filteredOrder.next(filtered);
      });
    this.logFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionLogisticsPoint) : this.dropdownOptionLogisticsPoint?.slice())
      )
      .subscribe(filtered => {
        this.filteredLog.next(filtered);
      });
    this.orderRegFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionOredrRegion) : this.dropdownOptionOredrRegion?.slice())
      )
      .subscribe(filtered => {
        this.filteredOrderReg.next(filtered);
      });


    this.orderFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionOredrTP) : this.dropdownOptionOredrTP?.slice())
      )
      .subscribe(filtered => {
        this.filteredOrderTp.next(filtered);
      });
    this.oderStsFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionOrderSts) : this.dropdownOptionOrderSts?.slice())
      )
      .subscribe(filtered => {
        this.filteredOrderSts.next(filtered);
      });
    this.plantFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionOrderPlant) : this.dropdownOptionOrderPlant?.slice())
      )
      .subscribe(filtered => {
        this.filteredPlant.next(filtered);
      });
  }

  private asNonEmptyString(value: unknown): string | null {
    if (value === null || value === undefined) {
      return null;
    }

    const normalized = String(value).trim();
    return normalized.length > 0 ? normalized : null;
  }

  private createOption(label: unknown, value: unknown): { label: string; value: string } | null {
    const normalizedLabel = this.asNonEmptyString(label);
    const normalizedValue = this.asNonEmptyString(value);

    if (!normalizedLabel || !normalizedValue) {
      return null;
    }

    return {
      label: normalizedLabel,
      value: normalizedValue,
    };
  }

  private filterOption(search: string, list: any): any[] {
    const filterValue = search.toLowerCase();
    return (list || []).filter(d =>
      d?.label?.toLowerCase()?.includes(filterValue) ||
      d?.value?.toLowerCase()?.includes(filterValue)
    );
  }
  isAllSelected(option: any, list: any): boolean {
    return option?.length == list?.length; // NOSONAR
  }

  isIndeterminate(option: any, list: any): boolean {
    return option?.length > 0 &&
      list?.length > 0 &&
      option?.length < list?.length;
  }


  toggleSelectAll(controlName: string, event: any, list: any[]): void {
    this.form.get(controlName)?.setValue(event.checked ? [...list] : []);
  }
  // async checkRoles() {
  //   await this.aetStateService.getRoles();
  //   const roles = this.aetStateService.getroleState();
  //   const userRoles = JSON?.parse(roles);
  //   if (
  //     userRoles &&
  //     (userRoles.includes(this.constants.LIOS_UAC_Admin) ||
  //       userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
  //       userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
  //       userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
  //       userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) ||
  //       userRoles.includes(this.constants.LIOS_UAC_AET_LP) ||
  //       userRoles.includes(this.constants.LIOS_UAC_General_User))
  //   ) {
  //     this.isAccessible = true;
  //   } else {
  //     this.router.navigate([`/home`]);
  //   }
  //   // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter ||
  //   //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
  //   //   // this.isAccessible = true;
  //   // } else {
  //   //   this.router.navigate([`/home`]);
  //   // }
  // }
  paramsMapping(original: any[], current: any[]): string[] {
    if (current.length == 0 || current.length == original.length) { return ['*']; } // NOSONAR
    return current.map((value) => value.label);
  }
  const_scanned = 'SCANNED ACTUAL'
  const_reload = 'PLANNED RELOAD START'
  const_reload_end = 'PLANNED RELOAD END'
  exportDashboardData(dashData, borderData) {
    const headers = [
      'ROUTE ID',
      'ROUTE',
      'LP',
      'ROUTE STATUS',
      'ROUTE TYPE',
      'DISPATCH NAME',
      'DISPATCH NA CODE',
      'DISPATCH CA CODE',
      'DISPATCH MTM CODE',
      'DISPATCH START',
      'DISPATCH END',
      'P/U 1 NAME',
      'P/U 1 NA CODE',
      'P/U 1 CA CODE',
      'P/U 1 MTM CODE',
      this.const_reload,
      this.const_reload_end,
      this.const_scanned,
      'P/U 2 NAME',
      'P/U 2 NA CODE',
      'P/U 2 CA CODE',
      'P/U 2 MTM CODE',
      this.const_reload,
      this.const_reload_end,
      this.const_scanned,
      'P/U 3 NAME',
      'P/U 3 NA CODE',
      'P/U 3 CA CODE',
      'P/U 3 MTM CODE',
      this.const_reload,
      this.const_reload_end,
      this.const_scanned,
      'P/U 4 NAME',
      'P/U 4 NA CODE',
      'P/U 4 CA CODE',
      'P/U 4 MTM CODE',
      this.const_reload,
      this.const_reload_end,
      this.const_scanned,
      'P/U 5 NAME',
      'P/U 5 NA CODE',
      'P/U 5 CA CODE',
      'P/U 5 MTM CODE',
      this.const_reload,
      this.const_reload_end,
      this.const_scanned,
      'P/U 6 NAME',
      'P/U 6 NA CODE',
      'P/U 6 CA CODE',
      'P/U 6 MTM CODE',
      this.const_reload,
      this.const_reload_end,
      this.const_scanned,
      'P/U 7 NAME',
      'P/U 7 NA CODE',
      'P/U 7 CA CODE',
      'P/U 7 MTM CODE',
      this.const_reload,
      this.const_reload_end,
      this.const_scanned,
      'P/U 8 NAME',
      'P/U 8 NA CODE',
      'P/U 8 CA CODE',
      'P/U 8 MTM CODE',
      this.const_reload,
      this.const_reload_end,
      this.const_scanned,
      'P/U 9 NAME',
      'P/U 9 NA CODE',
      'P/U 9 CA CODE',
      'P/U 9 MTM CODE',
      this.const_reload,
      this.const_reload_end,
      this.const_scanned,
      'P/U 10 NAME',
      'P/U 10 NA CODE',
      'P/U 10 CA CODE',
      'P/U 10 MTM CODE',
      this.const_reload,
      this.const_reload_end,
      this.const_scanned,
      'YARD NAME',
      'YARD NA CODE',
      'YARD CA CODE',
      'YARD MTM CODE',
      'YARD ARRIVAL START',
      'YARD ARRIVAL END',
      this.const_scanned,
      'UNLOAD START',
      'UNLOAD END',
      this.const_scanned,
      'BORDER 1',
      'PLANNED ARRIVAL DATE 1',
      'ACTUAL ARRIVAL DATE 1',
      'PLANNED DEPARTURE DATE 1',
      'ACTUAL DEPARTURE DATE 1',
      'BORDER 2',
      'PLANNED ARRIVAL DATE 2',
      'ACTUAL ARRIVAL DATE 2',
      'PLANNED DEPARTURE DATE 2',
      'ACTUAL DEPARTURE DATE 2',
      'BORDER 3',
      'PLANNED ARRIVAL DATE 3',
      'ACTUAL ARRIVAL DATE 3',
      'PLANNED DEPARTURE DATE 3',
      'ACTUAL DEPARTURE DATE 3',
      'BORDER 4',
      'PLANNED ARRIVAL DATE 4',
      'ACTUAL ARRIVAL DATE 4',
      'PLANNED DEPARTURE DATE 4',
      'ACTUAL DEPARTURE DATE 4',
    ];
    const exportData = [];
    console.info(borderData);
    dashData.forEach((e) => {
      const border = borderData[e.route_id];
      const obj = {
        ROUTE_ID: e.route_id,
        ROUTE: e.main_route,
        LP: e.transportation_provider,
        ROUTE_STATUS: e.route_status,
        ROUTE_TYPE: e.route_type,
        DISPATCH: e.dispatch_name,
        DISPATCH_NACODE: e.dispatch_nacode,
        DISPATCH_CACODE: e.dispatch_cacode,
        DISPATCH_MTMCODE: e.dispatch_mtmcode,
        DISPATCH_START: e.dispatch_start_date,
        DISPATCH_END: e.dispatch_end_date,
        PU_1: e.stop_1_name,
        PU_1_NACODE: e.stop_1_nacode,
        PU_1_CACODE: e.stop_1_cacode,
        PU_1_MTMCODE: e.stop_1_mtmcode,
        PLANNED_RELOAD_START_1: e.stop_1_parts_reload_start,
        PLANNED_RELOAD_END_1: e.stop_1_parts_reload_end,
        SCANNED_ACTUAL_1: e.stop_1_actual,
        PU_2: e.stop_2_name,
        PU_2_NACODE: e.stop_2_nacode,
        PU_2_CACODE: e.stop_2_cacode,
        PU_2_MTMCODE: e.stop_2_mtmcode,
        PLANNED_RELOAD_START_2: e.stop_2_parts_reload_start,
        PLANNED_RELOAD_END_2: e.stop_2_parts_reload_end,
        SCANNED_ACTUAL_2: e.stop_2_actual,
        PU_3: e.stop_3_name,
        PU_3_NACODE: e.stop_3_nacode,
        PU_3_CACODE: e.stop_3_cacode,
        PU_3_MTMCODE: e.stop_3_mtmcode,
        PLANNED_RELOAD_START_3: e.stop_3_parts_reload_start,
        PLANNED_RELOAD_END_3: e.stop_3_parts_reload_end,
        SCANNED_ACTUAL_3: e.stop_3_actual,
        PU_4: e.stop_4_name,
        PU_4_NACODE: e.stop_4_nacode,
        PU_4_CACODE: e.stop_4_cacode,
        PU_4_MTMCODE: e.stop_4_mtmcode,
        PLANNED_RELOAD_START_4: e.stop_4_parts_reload_start,
        PLANNED_RELOAD_END_4: e.stop_4_parts_reload_end,
        SCANNED_ACTUAL_4: e.stop_4_actual,
        PU_5: e.stop_5_name,
        PU_5_NACODE: e.stop_5_nacode,
        PU_5_CACODE: e.stop_5_cacode,
        PU_5_MTMCODE: e.stop_5_mtmcode,
        PLANNED_RELOAD_START_5: e.stop_5_parts_reload_start,
        PLANNED_RELOAD_END_5: e.stop_5_parts_reload_end,
        SCANNED_ACTUAL_5: e.stop_5_actual,
        PU_6: e.stop_5_name,
        PU_6_NACODE: e.stop_6_nacode,
        PU_6_CACODE: e.stop_6_cacode,
        PU_6_MTMCODE: e.stop_6_mtmcode,
        PLANNED_RELOAD_START_6: e.stop_6_parts_reload_start,
        PLANNED_RELOAD_END_6: e.stop_6_parts_reload_end,
        SCANNED_ACTUAL_6: e.stop_6_actual,
        PU_7: e.stop_7_name,
        PU_7_NACODE: e.stop_7_nacode,
        PU_7_CACODE: e.stop_7_cacode,
        PU_7_MTMCODE: e.stop_7_mtmcode,
        PLANNED_RELOAD_START_7: e.stop_7_parts_reload_start,
        PLANNED_RELOAD_END_7: e.stop_7_parts_reload_end,
        SCANNED_ACTUAL_7: e.stop_7_actual,
        PU_8: e.stop_8_name,
        PU_8_NACODE: e.stop_8_nacode,
        PU_8_CACODE: e.stop_8_cacode,
        PU_8_MTMCODE: e.stop_8_mtmcode,
        PLANNED_RELOAD_START_8: e.stop_8_parts_reload_start,
        PLANNED_RELOAD_END_8: e.stop_8_parts_reload_end,
        SCANNED_ACTUAL_8: e.stop_8_actual,
        PU_9: e.stop_9_name,
        PU_9_NACODE: e.stop_9_nacode,
        PU_9_CACODE: e.stop_9_cacode,
        PU_9_MTMCODE: e.stop_9_mtmcode,
        PLANNED_RELOAD_START_9: e.stop_9_parts_reload_start,
        PLANNED_RELOAD_END_9: e.stop_9_parts_reload_end,
        SCANNED_ACTUAL_9: e.stop_9_actual,
        PU_10: e.stop_5_name,
        PU_10_NACODE: e.stop_10_nacode,
        PU_10_CACODE: e.stop_10_cacode,
        PU_10_MTMCODE: e.stop_10_mtmcode,
        PLANNED_RELOAD_START_10: e.stop_10_parts_reload_start,
        PLANNED_RELOAD_END_10: e.stop_10_parts_reload_end,
        SCANNED_ACTUAL_10: e.stop_10_actual,
        YARD: e.yard_name,
        YARD_NACODE: e.yard_nacode,
        YARD_CACODE: e.yard_cacode,
        YARD_MTMCODE: e.yard_mtmcode,
        YARD_ARRIVAL_START: e.yard_arrival_start,
        YARD_ARRIVAL_END: e.yard_arrival_end,
        YARD_ACTUAL: e.yard_arrival_actual,
        UNLOAD_START: e.unload_start,
        UNLOAD_END: e.unload_end,
        UNLOAD_ACTUAL:
          e.route_type == 'Sub Route' ? e.yard_arrival_actual : e.unload_actual, // NOSONAR
        border1: border.border1,
        plannedArrivalDate1: border.plannedArrivalDate1,
        actualArrivalDate1: border.actualArrivalDate1,
        plannedDepartureDate1: border.plannedDepartureDate1,
        actualDepartureDate1: border.actualDepartureDate1,
        border2: border.border2,
        plannedArrivalDate2: border.plannedArrivalDate2,
        actualArrivalDate2: border.actualArrivalDate2,
        plannedDepartureDate2: border.plannedDepartureDate2,
        actualDepartureDate2: border.actualDepartureDate2,
        border3: border.border3,
        plannedArrivalDate3: border.plannedArrivalDate3,
        actualArrivalDate3: border.actualArrivalDate3,
        plannedDepartureDate3: border.plannedDepartureDate3,
        actualDepartureDate3: border.actualDepartureDate3,
        border4: border.border4,
        plannedArrivalDate4: border.plannedArrivalDate4,
        actualArrivalDate4: border.actualArrivalDate4,
        plannedDepartureDate4: border.plannedDepartureDate4,
        actualDepartureDate4: border.actualDepartureDate4,
      };

      exportData.push(obj);
    });
    this.excelService.exportAsExcelFile(
      exportData,
      'Export_Cross_Border',
      headers
    );
  }
  dateFormatter(res) {
    return res
      ? DateTime.fromFormat(res, 'MM-dd-yyyy HH:mm:ss', {
        zone: 'UTC-5',
        setZone: true,
      }).toFormat('MM/dd/yyyy HH:mm') + ` (EST)`
      : null;
  }
  cellChange(paramsDate, actualDate, yellowTrigger, redTrigger) {
    if (
      -1 * (Date.parse(paramsDate) - Date.parse(actualDate)) <
      yellowTrigger * 60 * 1000
    ) {
      return 'lightgreen';
    } else if (
      -1 * (Date.parse(paramsDate) - Date.parse(actualDate)) <
      redTrigger * 60 * 1000
    ) {
      return 'yellow';
    } else {
      return 'red';
    }
  }

  statusWrap(item, yellowTrigger, redTrigger) {
    if (item.route_status != null) { // NOSONAR
      return item.route_status;
    }
    if (item.yard_arrival_actual != null && item.yard_arrival_actual != '') { // NOSONAR
      return 'Arrived';
    }
    const statusStore = this.statusChange(item, yellowTrigger, redTrigger);
    if (statusStore == 'Late') { // NOSONAR
      return statusStore;
    } else {
      const currDate = new Date().getTime();
      const dispatchDate = new Date(
        item.route_type == 'LTL'  // NOSONAR
          ? item.stop_1_parts_reload_start
          : item.dispatch_end_date
      ).getTime();
      if (currDate > dispatchDate) {
        return this.const_prgrs;
      } else {
        return this.const_started;
      }
    }
  }
  statusChange(item, yellowTrigger, redTrigger) { // NOSONAR
    let cellValue: boolean = true;
    cellValue = this.statusChangeStop(
      item.stop_1_parts_reload_end,
      item.stop_1_actual,
      yellowTrigger,
      redTrigger
    );
    if (!cellValue && item.stop_1_nacode != null) { // NOSONAR
      return 'Late';
    }
    cellValue = this.statusChangeStop(
      item.stop_2_parts_reload_end,
      item.stop_2_actual,
      yellowTrigger,
      redTrigger
    );
    if (!cellValue && item.stop_2_nacode != null) { // NOSONAR
      return 'Late';
    }
    cellValue = this.statusChangeStop(
      item.stop_3_parts_reload_end,
      item.stop_3_actual,
      yellowTrigger,
      redTrigger
    );
    if (!cellValue && item.stop_3_nacode != null) { // NOSONAR
      return 'Late';
    }
    cellValue = this.statusChangeStop(
      item.stop_4_parts_reload_end,
      item.stop_4_actual,
      yellowTrigger,
      redTrigger
    );
    if (!cellValue && item.stop_4_nacode != null) { // NOSONAR
      return 'Late';
    }
    cellValue = this.statusChangeStop(
      item.stop_5_parts_reload_end,
      item.stop_5_actual,
      yellowTrigger,
      redTrigger
    );
    if (!cellValue && item.stop_5_nacode != null) { // NOSONAR
      return 'Late';
    }
    cellValue = this.statusChangeStop(
      item.stop_6_parts_reload_end,
      item.stop_6_actual,
      yellowTrigger,
      redTrigger
    );
    if (!cellValue && item.stop_6_nacode != null) { // NOSONAR
      return 'Late';
    }
    cellValue = this.statusChangeStop(
      item.stop_7_parts_reload_end,
      item.stop_7_actual,
      yellowTrigger,
      redTrigger
    );
    if (!cellValue && item.stop_7_nacode != null) { // NOSONAR
      return 'Late';
    }
    cellValue = this.statusChangeStop(
      item.stop_8_parts_reload_end,
      item.stop_8_actual,
      yellowTrigger,
      redTrigger
    );
    if (!cellValue && item.stop_8_nacode != null) { // NOSONAR
      return 'Late';
    }
    cellValue = this.statusChangeStop(
      item.stop_9_parts_reload_end,
      item.stop_9_actual,
      yellowTrigger,
      redTrigger
    );
    if (!cellValue && item.stop_9_nacode != null) { // NOSONAR
      return 'Late';
    }
    cellValue = this.statusChangeStop(
      item.stop_10_parts_reload_end,
      item.stop_10_actual,
      yellowTrigger,
      redTrigger
    );
    if (!cellValue && item.stop_10_nacode != null) { // NOSONAR
      return 'Late';
    }
    return 'No Delay';
  }
  getTimezone() {
    const td = DateTime.fromJSDate(new Date()).setZone('UTC-5');
    const toDate = td.toFormat('MM/dd/yyyy HH:mm');
    return toDate;
  }

  statusChangeStop(reloadEnd, actual, yellowTrigger, redTrigger) {
    let cellChangeValue1;
    if (actual == undefined || actual == null) {  // NOSONAR
      cellChangeValue1 = this.cellChange(
        reloadEnd?.substring(0, 16),
        this.getTimezone(),
        yellowTrigger,
        redTrigger
      );
      if (cellChangeValue1 == 'lightgreen') { // NOSONAR
        return true;
      } else {
        return false;
      }
    } else {
      cellChangeValue1 = this.cellChange(
        reloadEnd?.substring(0, 16),
        actual.substring(0, 16),
        yellowTrigger,
        redTrigger
      );
      if (cellChangeValue1 == 'lightgreen') {  // NOSONAR
        return true;
      } else {
        return false;
      }
    }
  }
  dashDataFormat(dashData) {
    dashData = dashData.map((item: any) => {
      let triggerData = this.masterSettingResponse.find(
        (value) => item.dispatch_nacode == value.domicile
      );
      if (!triggerData) {
        triggerData = this.masterSettingResponse.find(
          (value) => 'DEFAULT' == value.domicile // NOSONAR
        );
      }
      return {
        ...item,
        last_updated: this.dateFormatter(item.last_updated),
        unload_start: this.dateFormatter(item.unload_start),
        unload_end: this.dateFormatter(item.unload_end),
        eta: this.dateFormatter(item.eta),
        next_connection: this.dateFormatter(item.next_connection),
        order_number: '',
        route_status: this.statusWrap(
          item,
          triggerData?.yellowTrigger,
          triggerData?.redTrigger
        ),
        stop_1_parts_reload_start: this.dateFormatter(
          item.stop_1_parts_reload_start
        ),
        stop_1_parts_reload_end: this.dateFormatter(
          item.stop_1_parts_reload_end
        ),
        stop_1_actual: this.dateFormatter(item.stop_1_actual),

        stop_2_parts_reload_start: this.dateFormatter(
          item.stop_2_parts_reload_start
        ),
        stop_2_parts_reload_end: this.dateFormatter(
          item.stop_2_parts_reload_end
        ),
        stop_2_actual: this.dateFormatter(item.stop_2_actual),

        stop_3_parts_reload_start: this.dateFormatter(
          item.stop_3_parts_reload_start
        ),
        stop_3_parts_reload_end: this.dateFormatter(
          item.stop_3_parts_reload_end
        ),
        stop_3_actual: this.dateFormatter(item.stop_3_actual),

        stop_4_parts_reload_start: this.dateFormatter(
          item.stop_4_parts_reload_start
        ),
        stop_4_parts_reload_end: this.dateFormatter(
          item.stop_4_parts_reload_end
        ),
        stop_4_actual: this.dateFormatter(item.stop_4_actual),

        stop_5_parts_reload_start: this.dateFormatter(
          item.stop_5_parts_reload_start
        ),
        stop_5_parts_reload_end: this.dateFormatter(
          item.stop_5_parts_reload_end
        ),
        stop_5_actual: this.dateFormatter(item.stop_5_actual),

        stop_6_parts_reload_start: this.dateFormatter(
          item.stop_6_parts_reload_start
        ),
        stop_6_parts_reload_end: this.dateFormatter(
          item.stop_6_parts_reload_end
        ),
        stop_6_actual: this.dateFormatter(item.stop_6_actual),

        stop_7_parts_reload_start: this.dateFormatter(
          item.stop_7_parts_reload_start
        ),
        stop_7_parts_reload_end: this.dateFormatter(
          item.stop_7_parts_reload_end
        ),
        stop_7_actual: this.dateFormatter(item.stop_7_actual),

        stop_8_parts_reload_start: this.dateFormatter(
          item.stop_8_parts_reload_start
        ),
        stop_8_parts_reload_end: this.dateFormatter(
          item.stop_8_parts_reload_end
        ),
        stop_8_actual: this.dateFormatter(item.stop_8_actual),

        stop_9_parts_reload_start: this.dateFormatter(
          item.stop_9_parts_reload_start
        ),
        stop_9_parts_reload_end: this.dateFormatter(
          item.stop_9_parts_reload_end
        ),
        stop_9_actual: this.dateFormatter(item.stop_9_actual),

        stop_10_parts_reload_start: this.dateFormatter(
          item.stop_10_parts_reload_start
        ),
        stop_10_parts_reload_end: this.dateFormatter(
          item.stop_10_parts_reload_end
        ),
        stop_10_actual: this.dateFormatter(item.stop_10_actual),

        dispatch_start_date: this.dateFormatter(item.dispatch_start_date),
        dispatch_end_date: this.dateFormatter(item.dispatch_end_date),

        yard_arrival_start: this.dateFormatter(item.yard_arrival_start),
        yard_arrival_end: this.dateFormatter(item.yard_arrival_end),
        yard_arrival_actual: this.dateFormatter(item.yard_arrival_actual),
      };
    });

    if ( this.form.value.status.length == 0 || this.form.value.status.length == this.dropdownOptionOrderSts.length ) { // NOSONAR
      // do nothing
    } else {
      const reqStatus = this.form.value.status.map((val) => val.label);
      const data = dashData.filter((value) => {
        if (reqStatus.includes(value.route_status)) {
          return true;
        }
        return false;
      });
      dashData = data;
    }
    return dashData;
  }
  borderDataFormat(borderData) {
    const data: { [key: string]: any } = {};
    console.info(borderData);
    for (const [key, val] of Object.entries<any>(borderData)) {
      val.sort((a, b) => (a.seq < b.seq ? -1 : 1));
      const obj = {
        border1: val[0]?.borderCrossingName,
        plannedArrivalDate1: this.dateFormatter(val[0]?.plannedArrivalDate),
        actualArrivalDate1: this.dateFormatter(val[0]?.actualArrivalDate),
        plannedDepartureDate1: this.dateFormatter(val[0]?.plannedDepartureDate),
        actualDepartureDate1: this.dateFormatter(val[0]?.actualDepartureDate),
        border2: val[1]?.borderCrossingName,
        plannedArrivalDate2: this.dateFormatter(val[1]?.plannedArrivalDate),
        actualArrivalDate2: this.dateFormatter(val[1]?.actualArrivalDate),
        plannedDepartureDate2: this.dateFormatter(val[1]?.plannedDepartureDate),
        actualDepartureDate2: this.dateFormatter(val[1]?.actualDepartureDate),
        border3: val[2]?.borderCrossingName,
        plannedArrivalDate3: this.dateFormatter(val[2]?.plannedArrivalDate),
        actualArrivalDate3: this.dateFormatter(val[2]?.actualArrivalDate),
        plannedDepartureDate3: this.dateFormatter(val[2]?.plannedDepartureDate),
        actualDepartureDate3: this.dateFormatter(val[2]?.actualDepartureDate),
        border4: val[3]?.borderCrossingName,
        plannedArrivalDate4: this.dateFormatter(val[3]?.plannedArrivalDate),
        actualArrivalDate4: this.dateFormatter(val[3]?.actualArrivalDate),
        plannedDepartureDate4: this.dateFormatter(val[3]?.plannedDepartureDate),
        actualDepartureDate4: this.dateFormatter(val[3]?.actualDepartureDate),
      };
      data[key] = obj;
    }
    return data;
  }
  submitForm() {
    this.successMessage = null;
    this.errorMessage = null;
    const start = formatDate(this.form.value.start_Date, 'MM/dd/yyyy', 'en');
    const end = formatDate(this.form.value.end_Date, 'MM/dd/yyyy', 'en');
    const params = {
      supplier: this.paramsMapping(
        this.dropdownOptionOrderSupp,
        this.form.value.supplier
      ),
      plantCode: this.paramsMapping(
        this.dropdownOptionOrderPlant,
        this.form.value.plant
      ),
      logisticsPoint: this.paramsMapping(
        this.dropdownOptionLogisticsPoint,
        this.form.value.logisticsPoint
      ),
      reportRegion: this.paramsMapping(
        this.dropdownOptionOredrRegion,
        this.form.value.region
      ),
      orderVendor: this.paramsMapping(
        this.dropdownOptionOredrTP,
        this.form.value.transport_Provider
      ),
      reportStatus: this.paramsMapping(
        this.dropdownOptionOrderSts,
        this.form.value.status
      ),
      startDate: start,
      endDate: end,
    };
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.commonService.borderCrossingReport(params).subscribe(
      (response: any) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.exportDashboardData(
          this.dashDataFormat(response.body.dashData),
          this.borderDataFormat(response.body.borderData)
        );
      },
      (_error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.downloadError;
        setTimeout(() => {
          this.successMessage = null;
          this.errorMessage = null;
        }, 5000);
      }
    );
  }
  onDateChangedStart(event) {
    const value = event.target.value;
    if (!value) { return; }
    const currentDate = new Date(value);
    this.pastDate = new Date(currentDate.getTime() - 86400000);
    this.test = new Date(
      this.pastDate.getFullYear() - 5,
      this.pastDate.getMonth(),
      this.pastDate.getDate()
    );
    this.minDate = this.test.toISOString().split('T')[0];
    this.yesterday = this.pastDate.toISOString().split('T')[0];
  }
  onDateChangedEnd(event) {
    const value = event.target.value;
    if (!value) { return; }
    const currentDate = new Date(value);
    this.nextDate = new Date(currentDate.getTime() + 86400000);
    this.newDate = this.nextDate.toISOString().split('T')[0];
  }
}
